import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/system/Box';
import Button from '@mui/material/Button';

export default function Logo() {
  return (
    <>
    <Button href="#home" color="inherit">
      <Typography
      component='h2'
      variant="h6"
      >SC</Typography>
      </Button>
    </>
  );
}